import { render, staticRenderFns } from "./EvalVendor.vue?vue&type=template&id=d2572ca2&"
import script from "./EvalVendor.vue?vue&type=script&lang=js&"
export * from "./EvalVendor.vue?vue&type=script&lang=js&"
import style0 from "./EvalVendor.vue?vue&type=style&index=0&id=d2572ca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports